import React from 'react';
import { DialogTrigger } from 'react-aria-components';

const ModalDialogTrigger = ({ children }) => {
  return React.createElement(DialogTrigger, null, children);
};

export { ModalDialogTrigger };
//# sourceMappingURL=Trigger.es.js.map
